import { IAutomationObject } from '../../types'

export interface ISP_OutsideConditions extends IAutomationObject {
}

export const schema = 'AutomationApps.SubPlants.OutsideConditions.SP_OutsideConditions';
